
export const stripHtmlFromText = (html) => {
    if (!html) return '';
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || '';
  };
  
// 문자열에서 텍스트 노드만 추출하는 함수
const extractTextNodes = (htmlContent) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    const textNodes = [];
    
    // 텍스트 노드 추출 함수
    const walkTree = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent.trim();
        if (text) {
          textNodes.push(text);
        }
      } else {
        // p, div, li 등 의미 있는 단락 요소의 경우
        const isBlockElement = node.nodeType === Node.ELEMENT_NODE && 
          ['P', 'DIV', 'LI', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'BLOCKQUOTE'].includes(node.tagName);
        
        // 각 자식 노드 처리
        for (let i = 0; i < node.childNodes.length; i++) {
          walkTree(node.childNodes[i]);
          
          // 블록 요소 사이에 구분자 추가
          if (isBlockElement && i < node.childNodes.length - 1) {
            textNodes.push("."); // 문장 구분자 추가
          }
        }
      }
    };
    
    walkTree(doc.body);
    return textNodes;
  };

const detectLanguage = (text) => {
    // 한글이 일정 비율 이상 포함되어 있으면 한국어로 판단
    const koreanChars = text.match(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g) || [];
    const koreanRatio = koreanChars.length / text.length;
    
    return koreanRatio > 0.15 ? 'ko-KR' : 'en-US';
    };

export const playMixedLanguageTTS = (text, setIsSpeaking) => {  
    // 이전 음성을 취소

    window.speechSynthesis.cancel();
    if (setIsSpeaking) setIsSpeaking(true);
  
    // 텍스트에서 HTML 태그 제거 (hyperlink 포함)
    const plainText = stripHtmlFromText(text);
    
    // 문장 단위로 분리
    const paragraphs = plainText.match(/[^.!?]*[.!?]/g) || [plainText];
    const sentences = extractTextNodes(paragraphs); 
    const chunks = []; 

    // 4개 문장씩 청크로 묶기
    for (let i = 0; i < sentences.length; i += 4) {
        chunks.push(sentences.slice(i, i + 4).join(" ")); // 4문장씩 결합 
    } 

    // 음성을 순차적으로 재생
    const playChunk = (index) => {
      if (index >= chunks.length) {
        setIsSpeaking(false);
        return; // 모든 청크가 재생되었으면 종료
      }

      // 단락의 언어 감지
      const detectedLang = detectLanguage(chunks[index]);
      const utterance = new SpeechSynthesisUtterance(chunks[index]);
      
      // 언어별 최적화된 음성 설정
      utterance.lang = detectedLang;
      
      // 언어별 음성 최적화
      const voices = window.speechSynthesis.getVoices();
      
      if (detectedLang === 'ko-KR') {
        // 한국어 음성 최적화
        utterance.rate = 1.0; // 속도: 표준
        utterance.pitch = 1.0; // 음높이: 표준
        
        // 한국어 음성 선택
        const koreanVoice = voices.find(voice => 
          voice.lang === 'ko-KR' && voice.name.includes('Google')
        ) || voices.find(voice => voice.lang === 'ko-KR');
        
        if (koreanVoice) utterance.voice = koreanVoice;
      } else {
        // 영어 음성 최적화
        utterance.rate = 0.9; // 속도: 약간 느리게
        utterance.pitch = 1.0; // 음높이: 표준
        
        // 영어 음성 선택 (Samantha, Alex, 또는 Google US 음성 선호)
        const englishVoice = voices.find(voice => 
          (voice.name === 'Samantha' || voice.name === 'Alex' || 
          (voice.lang === 'en-US' && voice.name.includes('Google')))
        ) || voices.find(voice => voice.lang === 'en-US');
        
        if (englishVoice) utterance.voice = englishVoice;
      }
      
      // 문장 사이 자연스러운 휴지(pause) 추가 

      utterance.onend = () => {
        setTimeout(() => {
            playChunk(index + 1); // 현재 청크가 끝나면 다음 청크 재생
        }, 250); // 250ms의 휴지 추가
      };
      
      utterance.onerror = (e) => {
        console.error('Error in speech synthesis:', e);
        if (setIsSpeaking) setIsSpeaking(false);
      };
      
      window.speechSynthesis.speak(utterance); 
    }; 
    // 첫 번째 청크부터 재생 시작 
    playChunk(0); 
  };

  // TTS 중지 함수
  export const stopSpeech = (setIsSpeaking) => {
    window.speechSynthesis.cancel();
    if (setIsSpeaking) setIsSpeaking(false);
  };